import Icon from '../components/Icon.vue'

Icon.register({
  'sort-down': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M41 288H279C300.4 288 311.1 313.9 296 329L177 448C167.6 457.4 152.4 457.4 143.1 448L24 329C8.9 313.9 19.6 288 41 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sort-down.js
// module id = VPTh
// module chunks = 144